module.exports = __webpack_public_path__ + "media/application/images/projects/secondary_nav/minerals-big-546cc33cb2d3aa366b5e05c1e98168a4.jpg";